import React, { useEffect, useState } from 'react'
import {
  TableItemBody,
  TableItemContainer,
} from 'components/Table/Table.styled'
import { TransactionBalanceItemProps } from '.'
import CheckBox from 'components/CheckBox/CheckBox'
import { PENNIES } from 'utils/rate'

const TransactionBalanceItem = ({
  invoice,
  onSelected,
  pennies
}: TransactionBalanceItemProps) => {
  const [checked, setChecked] = useState<boolean>(false)
  const amount = pennies ? invoice.amount / PENNIES : invoice.amount

  useEffect(() => {
    const clientInvoice = { ...invoice }
    if (checked) {
      clientInvoice.remove = false
      onSelected(clientInvoice)
    } else {
      clientInvoice.remove = true
      onSelected(clientInvoice)
    }
  }, [checked])

  const handleSelected = () => {
    setChecked(!checked)
  }

  return (
    <TableItemContainer
      onClick={handleSelected}
      style={{cursor: 'pointer'}}
    >
      <TableItemBody >
        <CheckBox
          weight="500"
          text=""
          checked={checked}
          disabled={true}
        />
      </TableItemBody>
      <TableItemBody>{invoice.id}</TableItemBody>
      <TableItemBody>{invoice.invoice_type}</TableItemBody>
      <TableItemBody>$ {(amount).toFixed(2)}</TableItemBody>
      <TableItemBody>{invoice.description}</TableItemBody>
    </TableItemContainer>
  )
}

export default TransactionBalanceItem
